import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse, X5LessonSnapshot} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder, StringControl, validators} from '../../../../lib/helpers';

export class UpdateSnapshotStore implements SaveStateHolder {
  version: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly snapshot: X5LessonSnapshot) {
    makeObservable(this);
    this.version = new StringControl('', '', validators.required);
    this.version.setValue(snapshot.Version);
    this.save = null;
  }

  @action
  complete() {
    this.version.markTouched();
    if (this.version.invalid)
      return;
    if (this.save?.isPending === true)
      return;
    this.save = contentLoaders.x5lessonSnapshot.update(
      this.snapshot.Id, this.version.value);
  }
}
